import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default async (baseUrl: string, projectId: string, id: string): Promise<void> => {
	const url = `${baseUrl}/rest/projects/1.0/project/${projectId}/shortcut/${id}`;
	return performDeleteRequest(url);
};
